<template>
  <div>
    <router-view class="view" keep-alive transition transition-mode="out-in" />
    <page-listar v-if="isIndexOnly()" />
  </div>
</template>

<script>
import Listar from './Listar'

export default {
  name: 'servico-motivo',
  data () {
    return {
      title: 'Motivos Não Instalação'
    }
  },
  components: {
    'page-listar': Listar
  },
  methods: {
    isIndexOnly () {
      return this.$router.currentRoute.path === '/servico-motivo' || this.$router.currentRoute.path === '/servico-motivo/'
    }
  },
  mounted () {
    this.$parent.$data.title = this.title
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/servico-motivo/index.vue